import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "payments-page__content payments-page__content--payment" }
const _hoisted_2 = { class: "payments-page__payments-block payments-block" }
const _hoisted_3 = { class: "result" }
const _hoisted_4 = { class: "result__title" }
const _hoisted_5 = { class: "result__sum" }
const _hoisted_6 = {
  key: 0,
  class: "result__visual"
}
const _hoisted_7 = { class: "result__text" }
const _hoisted_8 = {
  key: 1,
  class: "result__visual"
}
const _hoisted_9 = { class: "result__text" }
const _hoisted_10 = {
  key: 2,
  class: "result__visual"
}
const _hoisted_11 = { class: "result__text" }
const _hoisted_12 = {
  key: 3,
  class: "result__visual"
}
const _hoisted_13 = { class: "result__text" }
const _hoisted_14 = {
  class: "download-form__container download-form__container--payments download-form__container--fail",
  id: "drop-area"
}
const _hoisted_15 = {
  class: "download-form__text",
  id: "file-text"
}
const _hoisted_16 = {
  key: 4,
  class: "result__visual"
}
const _hoisted_17 = { class: "result__text" }
const _hoisted_18 = {
  key: 5,
  class: "result__visual"
}
const _hoisted_19 = { class: "result__text" }
const _hoisted_20 = {
  key: 6,
  class: "result__visual"
}
const _hoisted_21 = { class: "result__text" }
const _hoisted_22 = {
  key: 0,
  class: "payments-page__controls payments-page__controls--center"
}
const _hoisted_23 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('invoice.transfer-sum')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.invoice.sum.amount, _ctx.invoice.sum.currency)), 1)
        ]),
        (_ctx.isPaymentCanceled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "result__fail" }, [
                _createElementVNode("svg", {
                  width: "33",
                  height: "32",
                  viewBox: "0 0 33 32",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M4.87493 1.06214C4.43063 0.648142 3.84299 0.422757 3.2358 0.433471C2.62861 0.444184 2.04928 0.690158 1.61986 1.11957C1.19045 1.54899 0.944472 2.12832 0.933758 2.73551C0.923045 3.3427 1.14843 3.93035 1.56243 4.37464L13.1874 15.9996L1.56243 27.6246C1.33216 27.8392 1.14746 28.098 1.01936 28.3855C0.891264 28.673 0.822384 28.9833 0.816832 29.298C0.81128 29.6127 0.869168 29.9253 0.987047 30.2171C1.10492 30.509 1.28038 30.7741 1.50294 30.9966C1.72549 31.2192 1.9906 31.3946 2.28244 31.5125C2.57428 31.6304 2.88687 31.6883 3.20156 31.6827C3.51626 31.6772 3.82661 31.6083 4.11411 31.4802C4.40161 31.3521 4.66036 31.1674 4.87493 30.9371L16.4999 19.3121L28.1249 30.9371C28.3395 31.1674 28.5983 31.3521 28.8857 31.4802C29.1732 31.6083 29.4836 31.6772 29.7983 31.6827C30.113 31.6883 30.4256 31.6304 30.7174 31.5125C31.0093 31.3946 31.2744 31.2192 31.4969 30.9966C31.7195 30.7741 31.8949 30.509 32.0128 30.2171C32.1307 29.9253 32.1886 29.6127 32.183 29.298C32.1775 28.9833 32.1086 28.673 31.9805 28.3855C31.8524 28.098 31.6677 27.8392 31.4374 27.6246L19.8124 15.9996L31.4374 4.37464C31.8514 3.93035 32.0768 3.3427 32.0661 2.73551C32.0554 2.12832 31.8094 1.54899 31.38 1.11957C30.9506 0.690158 30.3713 0.444184 29.7641 0.433471C29.1569 0.422757 28.5692 0.648142 28.1249 1.06214L16.4999 12.6871L4.87493 1.06214Z",
                    fill: "#FF4747"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('invoice.payment-canceled-text')), 1)
            ]))
          : (_ctx.isPaymentCompleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "result__success" }, [
                  _createElementVNode("svg", {
                    width: "55",
                    height: "48",
                    viewBox: "0 0 55 48",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M53.5216 7.24252L21.2139 45.7041C20.8595 46.1262 20.4186 46.4672 19.9209 46.704C19.4232 46.9408 18.8804 47.0679 18.3293 47.0767H18.2644C17.7253 47.0765 17.1923 46.9629 16.6999 46.7435C16.2075 46.524 15.7668 46.2034 15.4062 45.8026L1.56008 30.418C1.20844 30.045 0.934897 29.6055 0.755533 29.1253C0.576168 28.6452 0.494604 28.134 0.515626 27.6218C0.536649 27.1096 0.659836 26.6068 0.877951 26.143C1.09607 25.6791 1.40471 25.2635 1.78574 24.9206C2.16676 24.5777 2.61249 24.3144 3.09671 24.1463C3.58094 23.9781 4.09389 23.9084 4.60543 23.9413C5.11697 23.9742 5.61677 24.109 6.07546 24.3379C6.53415 24.5667 6.94247 24.8849 7.27643 25.2738L18.1634 37.3699L47.6322 2.29541C48.2932 1.53117 49.2284 1.05776 50.2357 0.977494C51.2429 0.897231 52.2413 1.21657 53.015 1.86648C53.7887 2.51638 54.2756 3.44466 54.3704 4.45064C54.4652 5.45663 54.1603 6.45951 53.5216 7.24252Z",
                      fill: "#05CF2A"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('invoice.payment-success-text')), 1)
              ]))
            : (_ctx.isAcquiringWaitingForFunds)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    class: "loader",
                    viewBox: "0 0 60 60"
                  }, [
                    _createElementVNode("circle", {
                      class: "background",
                      cx: "30",
                      cy: "30",
                      r: "27"
                    }),
                    _createElementVNode("circle", {
                      class: "progress",
                      cx: "30",
                      cy: "30",
                      r: "27"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('invoice.acquiring-waiting-text')), 1)
                ]))
              : (_ctx.currentDeal && _ctx.currentDeal.status === _ctx.DealStatus.TRANSFER_CONFIRMED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("svg", {
                      class: "loader",
                      viewBox: "0 0 60 60"
                    }, [
                      _createElementVNode("circle", {
                        class: "background",
                        cx: "30",
                        cy: "30",
                        r: "27"
                      }),
                      _createElementVNode("circle", {
                        class: "progress",
                        cx: "30",
                        cy: "30",
                        r: "27"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('invoice.confirm-waiting-text')), 1),
                    (_ctx.disputeFile === null && !_ctx.hideUploadReceipt)
                      ? (_openBlock(), _createElementBlock("form", _mergeProps({
                          key: 0,
                          class: "download-form"
                        }, _ctx.dropzone.getRootProps()), [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                            _cache[5] || (_cache[5] = _createElementVNode("svg", {
                              width: "48",
                              height: "48",
                              viewBox: "0 0 48 48",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M35.25 33H25.5V18.6216L30.4397 23.5603C30.7233 23.8297 31.1009 23.9777 31.4921 23.9727C31.8832 23.9677 32.2569 23.8101 32.5335 23.5335C32.8101 23.2569 32.9677 22.8832 32.9727 22.492C32.9777 22.1009 32.8297 21.7233 32.5603 21.4397L25.0603 13.9397C24.779 13.6586 24.3977 13.5007 24 13.5007C23.6023 13.5007 23.221 13.6586 22.9397 13.9397L15.4397 21.4397C15.1703 21.7233 15.0223 22.1009 15.0273 22.492C15.0323 22.8832 15.1899 23.2569 15.4665 23.5335C15.7431 23.8101 16.1168 23.9677 16.508 23.9727C16.8991 23.9777 17.2767 23.8297 17.5603 23.5603L22.5 18.6216V33H12.75C11.3581 32.9985 10.0236 32.4449 9.03933 31.4607C8.05509 30.4764 7.50149 29.1419 7.5 27.75V8.25C7.50149 6.85807 8.05509 5.52358 9.03933 4.53933C10.0236 3.55509 11.3581 3.00149 12.75 3H35.25C36.6419 3.00149 37.9764 3.55509 38.9607 4.53933C39.9449 5.52358 40.4985 6.85807 40.5 8.25V27.75C40.4985 29.1419 39.9449 30.4764 38.9607 31.4607C37.9764 32.4449 36.6419 32.9985 35.25 33ZM25.5 43.5C25.5 43.8978 25.342 44.2794 25.0607 44.5607C24.7794 44.842 24.3978 45 24 45C23.6022 45 23.2206 44.842 22.9393 44.5607C22.658 44.2794 22.5 43.8978 22.5 43.5V33H25.5V43.5Z",
                                fill: "#77818D"
                              })
                            ], -1)),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('invoice.select-files')), 1),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                              class: "btn btn--accept download-form__btn"
                            }, [
                              _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M6.25 13.125V1.875L7.5 2.5L8.75 1.875L9.99766 2.5L11.2621 1.875L12.5 2.5L13.7418 1.875L14.9891 2.5L16.25 1.875L17.5004 2.5L18.75 1.875V10.625",
                                  stroke: "#F7F9FC",
                                  "stroke-width": "1.25",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M18.75 10.625V15C18.75 15.8288 18.4208 16.6237 17.8347 17.2097C17.2487 17.7958 16.4538 18.125 15.625 18.125M15.625 18.125C14.7962 18.125 14.0014 17.7958 13.4153 17.2097C12.8293 16.6237 12.5 15.8288 12.5 15V13.125H1.87502C1.79275 13.1243 1.71114 13.1399 1.63499 13.1711C1.55883 13.2022 1.48964 13.2482 1.43146 13.3064C1.37327 13.3646 1.32726 13.4338 1.29611 13.51C1.26496 13.5861 1.24929 13.6677 1.25002 13.75C1.25002 16.25 1.51331 18.125 4.37502 18.125H15.625Z",
                                  stroke: "#F7F9FC",
                                  "stroke-width": "1.25",
                                  "stroke-linejoin": "round"
                                }),
                                _createElementVNode("path", {
                                  d: "M8.75 5.625H16.25M11.25 8.75H16.25",
                                  stroke: "#F7F9FC",
                                  "stroke-width": "1.25",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('invoice.upload-doc')), 1)
                            ])
                          ])
                        ], 16))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.invoice.status === _ctx.InvoiceStatus.PAID)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "result__success" }, [
                        _createElementVNode("svg", {
                          width: "55",
                          height: "48",
                          viewBox: "0 0 55 48",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M53.5216 7.24252L21.2139 45.7041C20.8595 46.1262 20.4186 46.4672 19.9209 46.704C19.4232 46.9408 18.8804 47.0679 18.3293 47.0767H18.2644C17.7253 47.0765 17.1923 46.9629 16.6999 46.7435C16.2075 46.524 15.7668 46.2034 15.4062 45.8026L1.56008 30.418C1.20844 30.045 0.934897 29.6055 0.755533 29.1253C0.576168 28.6452 0.494604 28.134 0.515626 27.6218C0.536649 27.1096 0.659836 26.6068 0.877951 26.143C1.09607 25.6791 1.40471 25.2635 1.78574 24.9206C2.16676 24.5777 2.61249 24.3144 3.09671 24.1463C3.58094 23.9781 4.09389 23.9084 4.60543 23.9413C5.11697 23.9742 5.61677 24.109 6.07546 24.3379C6.53415 24.5667 6.94247 24.8849 7.27643 25.2738L18.1634 37.3699L47.6322 2.29541C48.2932 1.53117 49.2284 1.05776 50.2357 0.977494C51.2429 0.897231 52.2413 1.21657 53.015 1.86648C53.7887 2.51638 54.2756 3.44466 54.3704 4.45064C54.4652 5.45663 54.1603 6.45951 53.5216 7.24252Z",
                            fill: "#05CF2A"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('invoice.payment-success-text')), 1)
                    ]))
                  : _createCommentVNode("", true),
        (_ctx.invoice.status === _ctx.InvoiceStatus.NEW && _ctx.currentDeal === null && _ctx.waitingForRequisites === true && !_ctx.isAcquiringPayment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _cache[8] || (_cache[8] = _createElementVNode("svg", {
                class: "loader",
                viewBox: "0 0 60 60"
              }, [
                _createElementVNode("circle", {
                  class: "background",
                  cx: "30",
                  cy: "30",
                  r: "27"
                }),
                _createElementVNode("circle", {
                  class: "progress",
                  cx: "30",
                  cy: "30",
                  r: "27"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('invoice.waiting-payment-methods')), 1)
            ]))
          : (_ctx.invoice.status === _ctx.InvoiceStatus.NEW && _ctx.currentDeal === null && !_ctx.isAcquiringPayment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "result__fail" }, [
                  _createElementVNode("svg", {
                    width: "33",
                    height: "32",
                    viewBox: "0 0 33 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M4.87493 1.06214C4.43063 0.648142 3.84299 0.422757 3.2358 0.433471C2.62861 0.444184 2.04928 0.690158 1.61986 1.11957C1.19045 1.54899 0.944472 2.12832 0.933758 2.73551C0.923045 3.3427 1.14843 3.93035 1.56243 4.37464L13.1874 15.9996L1.56243 27.6246C1.33216 27.8392 1.14746 28.098 1.01936 28.3855C0.891264 28.673 0.822384 28.9833 0.816832 29.298C0.81128 29.6127 0.869168 29.9253 0.987047 30.2171C1.10492 30.509 1.28038 30.7741 1.50294 30.9966C1.72549 31.2192 1.9906 31.3946 2.28244 31.5125C2.57428 31.6304 2.88687 31.6883 3.20156 31.6827C3.51626 31.6772 3.82661 31.6083 4.11411 31.4802C4.40161 31.3521 4.66036 31.1674 4.87493 30.9371L16.4999 19.3121L28.1249 30.9371C28.3395 31.1674 28.5983 31.3521 28.8857 31.4802C29.1732 31.6083 29.4836 31.6772 29.7983 31.6827C30.113 31.6883 30.4256 31.6304 30.7174 31.5125C31.0093 31.3946 31.2744 31.2192 31.4969 30.9966C31.7195 30.7741 31.8949 30.509 32.0128 30.2171C32.1307 29.9253 32.1886 29.6127 32.183 29.298C32.1775 28.9833 32.1086 28.673 31.9805 28.3855C31.8524 28.098 31.6677 27.8392 31.4374 27.6246L19.8124 15.9996L31.4374 4.37464C31.8514 3.93035 32.0768 3.3427 32.0661 2.73551C32.0554 2.12832 31.8094 1.54899 31.38 1.11957C30.9506 0.690158 30.3713 0.444184 29.7641 0.433471C29.1569 0.422757 28.5692 0.648142 28.1249 1.06214L16.4999 12.6871L4.87493 1.06214Z",
                      fill: "#FF4747"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('invoice.no-available-methods-text')), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    ((!_ctx.receiptPdfRequired || _ctx.invoice.status === _ctx.InvoiceStatus.PAID) && (_ctx.invoice.status !== _ctx.InvoiceStatus.PAID && _ctx.invoice.cancelUrl || _ctx.invoice.status === _ctx.InvoiceStatus.PAID && _ctx.invoice.successUrl))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("a", {
            href: _ctx.invoice.status !== _ctx.InvoiceStatus.PAID ? _ctx.invoice.cancelUrl : _ctx.invoice.successUrl,
            class: "btn payments-page__close"
          }, _toDisplayString(_ctx.$t('invoice.return-to-merchant')), 9, _hoisted_23)
        ]))
      : _createCommentVNode("", true)
  ]))
}